<div class="modal-header">
  <h4 class="modal-title">Confirm Deletion</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()"><span aria-hidden="true">&times;</span></button>
</div>
<div class="modal-body">
  <p>Are you sure you want to delete the database : <strong>{{ dbName }}</strong>?</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="confirm()">Delete</button>
  <button type="button" class="btn btn-secondary" (click)="dismiss()">Cancel</button>
</div>
